module.exports = __webpack_public_path__ + "img/ar08.6ab2e90d.jpg";